module.exports = __webpack_public_path__ + "img/selected1-min.e09b053c.png";